import { render, staticRenderFns } from "./PropertiesMenu.vue?vue&type=template&id=7426c1c7&"
import script from "./PropertiesMenu.vue?vue&type=script&lang=js&"
export * from "./PropertiesMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports